import React, {useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";

import WithUpdateLookCartItem from "../../../hocs/withUpdateLookCartItem";
import LookFeatureImage from "../../../lookNavigation/lookMain/lookFeature/lookFeatureImage";
import WithAddToCartPostMessage from "../../../hocs/withAddToCartPostMessage";
import {setLookActiveCategory, setLookActiveFeature, setLookOverlayOpened} from "../../../../../actions/lookFunctions";
import Config from "../../../../../config";
import {getCartItemsArrayFromFeature, isInStock} from "../../../lookNavigation/lookFunctions2";
import LookCanvasContext from "../../../lookCanvasContext";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import WithChangeFeature from "../../../hocs/withChangeFeature";
import WithZoomToFeature from "../../../hocs/withZoomToFeature";
import {getFeatureGroupName, getFeatureIsLocked} from "../../../../../misc/helpers";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {LOOK_OVERLAYS} from "../../../core/constants";
import {pricingIsLocked} from "../../../lookNavigation/lookNavigationFunctions";

const GroheFeatureShort = (props) => {

  const {feature, intl, lookExpanded, qtActiveCategory, fabricatorData, setLookOverlayOpened} = props;
  const [addedToCart, setAddedToCart] = useState(0);

  const addToCartButtonClick = (updateLookCartItem, addToCartPostMessage) => {
    const featureLabel = Analytics.getSkuForAnalytics(feature);
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productSimilarListFeatureAddToCart + featureLabel);

    const featureGroup = feature.getParent();
    featureGroup.confirmedChange = true;

    let {isLixil} = pricingIsLocked();
    if (isLixil) {
      setAddedToCart(1);
      // history.push(getFeatureUrl(feature));
      updateLookCartItem(feature, true);
      addToCartPostMessage(getCartItemsArrayFromFeature(feature, 1, qtActiveCategory));
      return;
    }

    const featureIsLocked = getFeatureIsLocked(feature);
    if (featureIsLocked) {
      setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
    } else {
      setAddedToCart(1);
      updateLookCartItem(feature, true);
    }

  };
  //const featureGroup = feature.getParent();
  //const featureGroupName = getFeatureGroupName(featureGroup, intl, fabricatorData);

  const listFeatureClick = (event, imageCanvas, changeFeature, zoomToFeatureGroupByFeature) => {
    if (event.target.closest(".look-icon--delete")) {
      return
    }

    const featureLabel = Analytics.getSkuForAnalytics(feature);
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productSimilarListFeature + featureLabel);

    if (Config.isDevMode() && feature) {
      console.log("feature", feature);
    }
    if (lookExpanded) {
      document.querySelector(".lm").style.transition = "none";
      setTimeout(() => {
        document.querySelector(".lm").style.transition = "all 0.3s ease";
      }, 300)
    }

    zoomToFeatureGroupByFeature(feature)
    changeFeature(feature)
  }
  const inStock = isInStock(feature);

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <div className={"lk-feature grohe-feature grohe-feature--short "}>
          <WithZoomToFeature imageCanvas={imageCanvas}>
            {(zoomToFeatureGroup, zoomToFeatureGroupByFeature) => (
              <WithChangeFeature>
                {(changeFeature) => (
                  <div className={"grohe-feature--short-zoom"}
                       onClick={(event) => listFeatureClick(event, imageCanvas, changeFeature, zoomToFeatureGroupByFeature)}>
                    <LookFeatureImage forFeature={feature} withoutGallery={true}/>
                    <div className="lk-content">
                      <div className="lk-title">
                        <h2 className="lk-title__text bold">
                          {getFeatureGroupName(feature.getParent(), intl, fabricatorData)}
                        </h2>
                      </div>
                      {!inStock ? (
                        <div className="text-danger">
                          <FormattedMessage id={"grohe.feature.soldOut"}/>
                        </div>
                      ) : null}
                      <div className={"lk-title" + (addedToCart ? "" : " lk-title--hidden")}>
                        <div className="lk-title__text bold grohe-icontext">
                          <CheckIcon fontSize="small"/>
                          <span className="grohe-icontext__cell"><FormattedMessage id="grohe.feature.addedToCart" /></span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </WithChangeFeature>
            )}
          </WithZoomToFeature>
          {inStock ? (
            <div className={"grohe-feature__button " + ( addedToCart ? "grohe-feature__button--hidden" : "")}>
              <WithUpdateLookCartItem>
                {(updateLookCartItem) => (
                  <WithAddToCartPostMessage>
                    {(addToCartPostMessage) => (
                      <Button className={"look-button look-button--small grohe-look__button--small grohe-look__button--secondary"}
                              onClick={() => addToCartButtonClick(updateLookCartItem, addToCartPostMessage)}>
                        <FormattedMessage id={"grohe.feature.addToCartButton"}/>
                      </Button>
                    )}
                  </WithAddToCartPostMessage>
                )}
              </WithUpdateLookCartItem>
            </div>
          ) : null}
        </div>
      )}
    </LookCanvasContext.Consumer>
  )
};


const mapStateToProps = (store) => {
  const {lookExpanded, lookViewType, lookActiveCategory, lookActiveFeature} = store.lookState;
  const {activePreset, bvPresets} = store.bathroomVisualizerState;
  const {qtActiveCategory} = store.qtState;
  const {filterGroups} = store.filterState;
  const fabricatorData = store.fabricatorState;
  return {
    qtActiveCategory,
    fabricatorData,
    filterGroups,
    lookExpanded,
    lookViewType,
    lookActiveCategory,
    lookActiveFeature,
    activePreset,
    bvPresets,
  }
};

GroheFeatureShort.propTypes = {
  feature: PropTypes.shape(featureInterface),
  featureGroup: PropTypes.object,
  position: PropTypes.string,
}

const mapDispatchToProps = {
  setLookActiveFeature,
  setLookActiveCategory,
  setLookOverlayOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFeatureShort)
);
